import React, { useState } from "react";
import { Phone, Plus } from "lucide-react";
import PageHeader from "../../../../components/marketing/cloud-dashboard/header";
import { useNavigate } from "react-router-dom";
import {  VoiceConfig } from "../types";
import { ProgressBar } from "../../../../components/marketing/voice/voice-setup/progress-bar";
import { PhoneNumberStep } from "../../../../components/marketing/voice/voice-setup/phone-setup";
import { ConfigureSettingsStep } from "../../../../components/marketing/voice/voice-setup/configuration";
import { TestConnectionStep } from "../../../../components/marketing/voice/voice-setup/test-connection";
import { CompleteStep } from "../../../../components/marketing/voice/voice-setup/complete-setup";

const VoiceSetup: React.FC = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [config, setConfig] = useState<VoiceConfig>({
    selectedNumber: "",
    webhookUrl: "",
    recordingEnabled: true,
  });

  const handlePhoneNumberContinue = (number: string) => {
    setConfig({ ...config, selectedNumber: number });
    setCurrentStep(1);
  };

  const handleConfigContinue = (newConfig: VoiceConfig) => {
    setConfig(newConfig);
    setCurrentStep(2);
  };

  const handleTestContinue = () => {
    setCurrentStep(3);
  };

  const handleBack = () => {
    setCurrentStep(Math.max(0, currentStep - 1));
  };

  function onBack() {
    navigate("/cpas-dashboard");
  }

  function onActionButtonClick() {
    navigate("/campaigns/create");
  }

  return (
    <>
      <PageHeader
        title="Voice Communications"
        subtitle="Make and receive voice calls with AI-powered features"
        onBack={onBack}
        actionButtonText="Create Campaign"
        onActionButtonClick={onActionButtonClick}
        actionButtonIcon={<Plus size={16} />}
      />
      <div className="min-h-screen bg-gray-50 py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex justify-center mb-8">
            <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center">
              <Phone className="w-8 h-8 text-white" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-center mb-2">
            Set Up Voice Channel
          </h1>
          <p className="text-gray-600 text-center mb-12">
            Follow these simple steps to enable voice calling for your business
          </p>

          <ProgressBar currentStep={currentStep} />

          {currentStep === 0 && (
            <PhoneNumberStep onContinue={handlePhoneNumberContinue} />
          )}
          {currentStep === 1 && (
            <ConfigureSettingsStep
              selectedNumber={config.selectedNumber}
              onContinue={handleConfigContinue}
              onBack={handleBack}
            />
          )}
          {currentStep === 2 && (
            <TestConnectionStep
              selectedNumber={config.selectedNumber}
              onContinue={handleTestContinue}
              onBack={handleBack}
            />
          )}
          {currentStep === 3 && <CompleteStep config={config} />}
        </div>
      </div>
    </>
  );
};

export default VoiceSetup;
